<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-r-6'">

    <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="pr-16">
            <div class="h3 cardHeader">Tareas</div>
        </div>
        <div>
            <button mat-icon-button aria-label="search" (click)="NavigateToTaskSelection()">
                <mat-icon>search</mat-icon>
            </button>
        </div>
    </div>

    <mat-tab-group #matTabGroup [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
        class="task-tab">
        <ng-container *ngFor="let t of tabLabelList">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span id="teras-badge"
                        [matBadge]=" dateTaskCount.length > 0 || dateTaskCount.length ==0 ? dateTaskCount[t.id]?.count : 0"
                        matBadgeOverlap="false" matBadgeColor="warn">{{t.label}}</span>
                </ng-template>
                <mat-paginator class="table-pager paginator-b-raduis"
                    [length]="dateTaskCount.length > 0 || dateTaskCount.length ==0 ? dateTaskCount[t.id]?.count : 0"
                    [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
                <app-tareas-tab [dataSource]="dataSource" [DateTaskCount]="dateTaskCount"
                    [displayedColumns]="displayedColumns"></app-tareas-tab>
            </mat-tab>
        </ng-container>
    </mat-tab-group>

</div>